module.exports = __webpack_public_path__ + "img/k-ash-woman-back.3a658639.jpg";